import { format, formatDistanceToNowStrict } from "date-fns"

export const USER_TYPE_OPTIONS = [
  { value: "owner", label: "Customer owner" },
  { value: "team_member", label: "Team member" },
  { value: "concierge", label: "Concierge" },
  { value: "sms_only", label: "Texting only" },
  { value: "staff", label: "Staff" },
]

export const POD_AGENTS_TYPE_OPTION = {
  value: "pod_agents",
  label: "Pod agents",
}

export const USER_TYPE_LABELS = {
  owner: "Owner",
  team_member: "Team member",
  concierge: "Concierge",
  sms_only: "Texting only",
  staff: "Staff",
}

export const SUBSCRIPTION_OPTIONS = [
  { value: "live", label: "Live" },
  { value: "trial", label: "Trial" },
  { value: "past_due", label: "Past due" },
  { value: "ended", label: "Ended" },
  { value: "none", label: "None" },
]

export const SUBSCRIPTION_GROUP_COLORS = {
  live: "success",
  trial: "info",
  past_due: "warning",
  ended: "default",
}

export const LAST_LOGIN_OPTIONS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "stale_90d", label: "90+ days ago" },
  { value: "never", label: "Never" },
]

export const JOINED_OPTIONS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
]

export const MLS_STATIC_OPTIONS = [
  { id: "has", label: "Has any board" },
  { id: "none", label: "No board" },
]

export const CONCIERGE_STATIC_OPTIONS = [
  { id: "yes", label: "Has a concierge" },
  { id: "no", label: "No concierge" },
]

/**
 * URL <-> API mapping for the Users filters. Active only is ON by default;
 * the URL carries `active=all` only once staff turn it off.
 */
export const USER_FILTER_SPECS = {
  active: {
    default: "true",
    toParams: (value) =>
      value === "true" || value === "false" ? { active: value } : {},
  },
  type: { param: "type" },
  sub: { param: "subscription" },
  mls: {
    toParams: (value) => {
      if (!value) return {}
      if (value === "has") return { has_mls: "true" }
      if (value === "none") return { has_mls: "false" }
      return { mls_id: value }
    },
  },
  concierge: {
    toParams: (value) => {
      if (!value) return {}
      if (value === "yes") return { has_concierge: "true" }
      if (value === "no") return { has_concierge: "false" }
      return { concierge_user_id: value }
    },
  },
  login: { param: "last_login" },
  joined: { param: "joined" },
}

// Date-only values ("2026-11-04") are calendar days: parse them as local
// midnight, not UTC, or US time zones show the day before.
function parseDate(value) {
  const text = String(value)
  return new Date(/^\d{4}-\d{2}-\d{2}$/.test(text) ? `${text}T00:00:00` : text)
}

export function formatShortDate(value) {
  if (!value) return null
  const date = parseDate(value)
  if (Number.isNaN(date.getTime())) return null
  return format(date, "MMM d, yyyy")
}

export function formatRelative(value) {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return `${formatDistanceToNowStrict(date)} ago`
}

export function formatStatusText(value) {
  const text = String(value || "").replace(/_/g, " ")
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : ""
}

/** "Monthly · ends Nov 4, 2026" for the subscription cell. */
export function subscriptionDetail(subscription) {
  if (!subscription) return ""
  const parts = []
  if (subscription.plan) parts.push(formatStatusText(subscription.plan))
  const ends = formatShortDate(subscription.current_term_ends_at)
  if (ends) parts.push(`ends ${ends}`)
  return parts.join(" · ")
}

export function hasStaffFlag(user) {
  return Boolean(user?.is_staff || user?.is_superuser || user?.is_onebase_staff)
}
